import React, { FC, SyntheticEvent, useRef, useState } from 'react'

import fireChat from 'fireChat'
import useChatCustomer from 'Hooks/useChatCustomer'
import useEvent from 'Hooks/useEvent'
import useMounted from 'Hooks/useMounted'
import useThrottle from 'Hooks/useThrottle'
import Send from 'Icons/send.svg'

interface Props {
  chatId?: string
  showSignupForm(): void
}

const MessageForm: FC<Props> = ({ chatId, showSignupForm }) => {
  const [customer] = useChatCustomer()
  const [sending, setSending] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const isMounted = useMounted()

  const setTyping = useThrottle((timestamp = new Date()) => {
    if (!chatId) return
    void fireChat.setTyping(chatId, timestamp)
  }, 2000)

  const handleShowSignupForm = useEvent(() => {
    if (!customer || customer.isAnonymous) {
      showSignupForm()
    }
  })

  const handleChange = useEvent(() => setTyping())
  const handleSubmit = useEvent((e: SyntheticEvent) => {
    e.preventDefault()
    if (!chatId || !inputRef.current?.value) return

    const body = inputRef.current.value

    inputRef.current.value = ''
    setSending(true)
    setTyping(new Date(0))
    setTyping.flush()

    fireChat
      .createMessage(chatId, body)
      .then(() => {
        if (!isMounted()) return

        setSending(false)
        handleShowSignupForm()
      })
      .catch(() => {
        if (!isMounted()) return

        setSending(false)
        if (inputRef.current?.value == '') inputRef.current.value = body
      })
  })

  return (
    <div className="chatBox__dialog--footer">
      <form id="chatForm" onSubmit={handleSubmit}>
        <div className="chatBox__input-wrapper">
          <label className="sr-only" htmlFor="chat_type_message_field">
            Type your message
          </label>
          <input
            ref={inputRef}
            className="form-control mr-1"
            id="chat_type_message_field"
            placeholder="Type your message..."
            readOnly={!chatId || sending}
            type="text"
            onChange={handleChange}
          />
        </div>
        <button aria-label="Send" disabled={!chatId || sending} type="submit">
          {sending || !chatId ? <span className="spinner-wheel spinner-wheel-20" /> : <Send />}
        </button>
      </form>
    </div>
  )
}

export default MessageForm
